// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"293":"6f3e65df27689bd7","462":"d5673beeac923d59"}[chunkId] + ".js";
};